import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router';
import Login from './routes/auth/Login';
import { RequireAuth } from './lib/RequireAuth';
import DashboardLayout from './layouts/Dashboard/Dashboard';
import CatalogLayout from './layouts/Catalog/Catalog';
import RootLayout from './layouts/RootLayout/RootLayout';
import { RequireRole } from './lib/RequireRole';
import CreateSchoolForm from "./features/school-management/components/CreateSchoolForm/CreateSchoolForm";
import SchoolInformation from "./features/school-management/components/SchoolInformation/SchoolInformation";
import UpdateSchoolForm from "./features/school-management/components/UpdateSchoolForm/UpdateSchoolForm";
import SchoolList from "./features/school-management/components/SchoolList/SchoolList";
import ProfileEdit from "./features/school-admin/components/ProfileEdit/ProfileEdit";
import UserList from "./features/user-management/components/UserList/UserList";
import AddUserForm from "./features/user-management/components/AddUserForm/AddUserForm";
import EditUserForm from "./features/user-management/components/EditUserForm/EditUserForm";
import { UserRole } from './types/auth';
import Analytics from './features/analytics/Analytics';

// Subject Management Imports
import SubjectList from './features/subject-management/components/SubjectList/SubjectList';
import ModuleList from './features/subject-management/components/ModuleList/ModuleList';
import ModuleDetail from './features/subject-management/components/ModuleDetail/ModuleDetail';
import AddSubjectForm from './features/subject-management/components/AddSubjectForm/AddSubjectForm';
import EditSubjectForm from './features/subject-management/components/EditSubjectForm/EditSubjectForm';
import ModuleForm from './features/subject-management/components/ModuleForm/ModuleForm';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path='/login' element={<Login />} />
        <Route path='/admin-login' element={<Login />} />
        <Route path="/library" element={<CatalogLayout />} />
        <Route path="/library/:subjectSlug" element={<CatalogLayout />} />
        <Route path="/library/:subjectSlug/:moduleSlug" element={<CatalogLayout />} />

        {/* Protected Routes */}
        <Route element={<RequireAuth />}>
          <Route element={<RootLayout />}>
            <Route path="/" element={<DashboardLayout />} />

            <Route element={<RequireRole allowedRoles={[UserRole.SCHOOL_ADMIN, UserRole.SUPER_ADMIN, UserRole.STUDENT, UserRole.TEACHER]} />}>
              <Route path="/edit-profile" element={<ProfileEdit />} />
            </Route>

            <Route element={<RequireRole allowedRoles={[UserRole.SCHOOL_ADMIN, UserRole.STUDENT, UserRole.SUPER_ADMIN, UserRole.TEACHER]} />}>
              <Route path="/school-information" element={<SchoolInformation />} />
            </Route>

            <Route element={<RequireRole allowedRoles={[UserRole.SCHOOL_ADMIN, UserRole.SUPER_ADMIN]} />}>
              <Route path="/analytics" element={<Analytics />} />
            </Route>

            <Route element={<RequireRole allowedRoles={[UserRole.SCHOOL_ADMIN]} />}>
              <Route path="/update-school-information" element={<UpdateSchoolForm />} />
              <Route path="/user-management" element={<UserList />} />
              <Route path="/user-management/add" element={<AddUserForm />} />
              <Route path="/user-management/edit/:id" element={<EditUserForm />} />
            </Route>

            <Route element={<RequireRole allowedRoles={[UserRole.SUPER_ADMIN]} />}>
              <Route path="/school-management" element={<SchoolList />} />
              <Route path="/school-management/add" element={<CreateSchoolForm />} />
              <Route path="/school-management/view/:id" element={<SchoolInformation />} />
              <Route path="/school-management/edit/:id" element={<UpdateSchoolForm />} />
            </Route>

            {/* Subject Management Routes */}
            <Route element={<RequireRole allowedRoles={[UserRole.SCHOOL_ADMIN, UserRole.STUDENT, UserRole.SUPER_ADMIN, UserRole.TEACHER]} />}>
              <Route path="/subject" element={<SubjectList />} />
              <Route path="/subject/:subjectSlug" element={<ModuleList />} />
              <Route path="/subject/:subjectSlug/:moduleSlug" element={<ModuleDetail />} />
            </Route>

            <Route element={<RequireRole allowedRoles={[UserRole.SUPER_ADMIN]} />}>
              <Route path="/subject/add" element={<AddSubjectForm />} />
              <Route path="/subject/edit/:subjectSlug" element={<EditSubjectForm />} />
              <Route path="/subject/:subjectSlug/add-module" element={<ModuleForm mode="add" />} />
              <Route path="/subject/:subjectSlug/edit-module/:moduleSlug" element={<ModuleForm mode="edit" />} />
            </Route>
          </Route>
        </Route>
        {/* catch all */}
        <Route path="/*" element={<div>Missing</div>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
